import React, { useEffect, useMemo } from 'react';
import { compareMatrices } from 'constants/matrices';
import { useCanEdit } from 'hooks/matrices';
import './ModificationsSidebar.scss';
import { nodeSortFunction } from 'constants/nodes';
import {
  OverridesListElement,
  OverrideElement,
  OverrideElementTrophicLevel,
  OverridesListElementTrophicLevel,
} from 'components/Overrides';

const ModificationsSidebar = ({ experiment, matrix }) => {
  let allNodes = { ...matrix.nodes, ...experiment.nodes };

  const overrides = compareMatrices(matrix, experiment);
  const canEdit = useCanEdit();
  const editable = canEdit(experiment);

  // Sorts the nodes by trophic level
  const nodesSorted = Object.values(allNodes)
    .filter(node => overrides[node.id].length > 0)
    .sort((a, b) => nodeSortFunction(a, b));

  const trophicLevelChanges = useMemo(() => {
    return overrides?.['trophicLevels'] ?? [];
  }, [overrides]);

  return (
    <div className="ModificationsSidebar">
      <ul className="ModificationsSidebar-nodeList">
        {trophicLevelChanges?.length ? (
          <div className="ModificationsSidebar-section-title">
            Trophic levels
          </div>
        ) : null}
        {trophicLevelChanges.map((override, i) => (
          <OverrideElementTrophicLevel key={i} override={override} />
        ))}
        {nodesSorted?.length ? (
          <div className="ModificationsSidebar-section-title">Nodes</div>
        ) : null}
        {nodesSorted.map(node => (
          <OverridesListElement
            key={node.id}
            editable={editable}
            node={node}
            overrides={overrides[node.id]}
          >
            {overrides[node.id].map((override, i) => (
              <OverrideElement
                key={i}
                editable={editable}
                override={override}
                experiment={experiment}
                matrix={matrix}
              />
            ))}
          </OverridesListElement>
        ))}
      </ul>
    </div>
  );
};

export default ModificationsSidebar;
